import { createStyles, makeStyles } from "@material-ui/core/styles";
const FTLTablePaginationActionsStyles = makeStyles((theme) => createStyles({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));
export default FTLTablePaginationActionsStyles;
//# sourceMappingURL=FTLTablePaginationActionsStyles.js.map